import { Settings } from "lucide-react";

import { Tab } from "@/types/tabs";

import {
  WORKSPACE_TABS_CONFIG,
  WorkspaceAdminTabs,
} from "./WorkspaceAdminTabs";

interface WorkspaceAdminHeaderProps {
  initialTab?: string;
  tabs?: Tab[];
}

export function WorkspaceAdminHeader({
  initialTab = WORKSPACE_TABS_CONFIG[0].key,
  tabs = WORKSPACE_TABS_CONFIG,
}: WorkspaceAdminHeaderProps) {
  return (
    <div className="bg-white border-b pt-2 md:pt-7">
      <div className="max-w-6xl mx-auto px-4 xl:px-0">
        <div className="items-center gap-3 hidden md:flex">
          <Settings className="w-7 h-7 text-blue-600" />
          <div className="text-3xl font-serif font-semibold">Workspace</div>
        </div>
        {tabs && tabs.length > 0 && (
          <div className="md:mt-2">
            <WorkspaceAdminTabs tabs={tabs} initialTab={initialTab} />
          </div>
        )}
      </div>
    </div>
  );
}
